
// outsource dependencies
import { toastr } from 'react-redux-toastr';
import { create } from 'redux-saga-controller';
import { takeEvery, put, call } from 'redux-saga/effects';

// local dependencies
import { instanceAPI } from '../../services';
import { silence, SIGN_IN } from '../../constant';

// configure
export const forgotPasswordCtrl = create({
  prefix: 'forgot-password',
  actions: {
    initialize: 'INITIALIZE',
    updateData: 'UPDATE_DATA'
  },
  initial: {
    disabled: false,
    initialValues: {},
    initialized: false,
    errorMessage: null,
  },
  subscriber: function * () {
    yield takeEvery(forgotPasswordCtrl.action.initialize.TYPE, silence, initializeSaga);
    yield takeEvery(forgotPasswordCtrl.action.updateData.TYPE, silence, updateDataSaga);
  }
});

function * initializeSaga ({ type, payload }) {
  // console.log(`%c ${type} `, 'color: #FF6766; font-weight: bolder; font-size: 12px;'
  //   , '\n payload:', payload
  // );
  // NOTE do nothing
  yield put(forgotPasswordCtrl.action.updateCtrl({ initialized: true }));
}

function * updateDataSaga ({ type, payload }) {
  // console.log(`%c ${type} `, 'color: #FF6766; font-weight: bolder; font-size: 12px;'
  //   , '\n payload:', payload
  // );
  yield put(forgotPasswordCtrl.action.updateCtrl({ disabled: true, errorMessage: null }));
  try {
    yield call(instanceAPI, { method: 'POST', url: '/users/send-reset-password-email', data: payload });
    yield call(toastr.warning, 'Estative', 'Email sent successfully. Please check your mailbox.');
    yield call(SIGN_IN.PUSH, {});
  } catch ({ message }) {
    yield call(toastr.error, 'Error', message);
    yield put(forgotPasswordCtrl.action.updateCtrl({ errorMessage: message }));
  }
  yield put(forgotPasswordCtrl.action.updateCtrl({ disabled: false }));
}
